export default __webpack_public_path__ + "45804072b3382e3f6197512a4af18a08.png";